<template>
    <div class="editable-text-cell">
        <el-tooltip class="cell-text-tooltip" :content="displayValue" v-if="!editing" placement="top" effect="dark">
            <span class="cell-text" @click="handleEdit">
                {{ displayValue }}
                <i class="el-icon-edit edit-icon" v-if="disabledProp" style="margin-left: 5px;"></i>
            </span>
        </el-tooltip>
        <div v-else class="cell-edit">
            <!-- @keyup.enter.native="handleSave" -->
            <el-input
                ref="input"
                v-model="inputValue"
                size="mini"
                type="textarea"
                :rows="2"
                class="editable-input"
                maxlength="200"
                show-word-limit
                resize="none"
                @keyup.esc.native="handleCancel"
            />
            <i class="el-icon-check check-icon" v-if="disabledProp" @click="handleSave"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditableTextCell',
    props: {
        value: {
            type: String,
            default: ''
        },
        editing: {
            type: Boolean,
            default: false
        },
        disabledProp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            inputValue: ''
        }
    },
    computed: {
        displayValue() {
            return this.value || '--'
        }
    },
    watch: {
        editing(newVal) {
            if (newVal) {
                this.inputValue = this.value || ''
                this.$nextTick(() => {
                    if (this.$refs.input) {
                        this.$refs.input.focus()
                    }
                })
            }
        }
    },
    methods: {
        handleEdit() {
            this.$emit('edit')
        },
        handleSave() {
            this.$emit('save', this.inputValue)
        },
        handleCancel() {
            this.$emit('cancel')
        }
    }
}
</script>

<style lang="scss" scoped>
.editable-text-cell {
    .cell-text {
        cursor: pointer;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;      // 显示2行
        max-width: 250px;
        width: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        
        .edit-icon {
            // 多行省略时图标可能需要调整位置
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 1;
            color: #409EFF;
            font-size: 14px;
        }
    }

    .cell-edit {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        .editable-input {
            margin-top: 20px;
            width: 250px;
        }

        .check-icon {
            cursor: pointer;
            color: #67C23A;
            font-size: 16px;
            // margin-left: 5px;
            // margin-top: 5px;

            &:hover {
                color: #85ce61;
            }
        }
    }
}
</style>
